import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  UpdateConsentConditionsAccepted,
  fetchPrivacyPolicyAndTermsAndConditionsData,
} from "../../services/user/ConsentService";

export const fetchConsentDataAsync = createAsyncThunk(
  "user/fetchApplicationDetails",
  async (key: any, thunkAPI) => {
    const response = await fetchPrivacyPolicyAndTermsAndConditionsData(key);
    return response;
  }
);

export const UpdateConsentConditionAsync = createAsyncThunk(
  "user/removeApplication",
  async (data: any, thunkAPI) => {
    const response = await UpdateConsentConditionsAccepted(data);
    return response;
  }
);
